import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles(() =>
  createStyles({
    select: {
      minWidth: 120,
    },
    menuItem: {
      width: '100%'
    },
  }),
);

export const useOutlinedInputStyles = makeStyles((theme: Theme) => ({
  root: {
    borderRadius: '2px',
    backgroundColor: theme.palette.light[100],
    '& .MuiOutlinedInput-notchedOutline': {
      border: `2px solid ${theme.palette.dark[300]}`,
    },
    '& .MuiOutlinedInput-root': {
      border: `2px solid ${theme.palette.light[100]}`,
      borderColor: theme.palette.light[100],
      maxWidth: 120,
    },
    '&:hover $notchedOutline': {
      borderColor: theme.palette.common.black,
    },
    '&$focused $notchedOutline': {
      border: `2px solid ${theme.palette.common.black}`,
    },
  },
  focused: {},
  notchedOutline: {},
}), { index: 1 });
